<template>
 <v-card>
   <div v-if="isLoading === true">로딩중</div>
  <v-list shaped v-if="restaurants.length > 0">
      <restaurant-cell v-for="restaurant in restaurants" :key="restaurant.gid" :restaurant="restaurant"></restaurant-cell>
  </v-list>
  </v-card>
</template>

<script>
import RestaurantCell from "@/components/RestaurantCell";
import store from "@/store.js";

export default {
  name: "RestaurantList",
  store,
  components: {
    RestaurantCell
  },
  data: function() {
    return {
      restaurants: this.$store.state.restaurants,
      isLoading : false
    };
  },
  methods: {
    getRestaurants: async function() {
      if (store.getters.isAuthenticated) {
        this.isLoading = true
        await this.$store.dispatch("getRestaurants");
        this.isLoading = false
      }
    }
  },
  mounted: function() {
    this.getRestaurants();
  }
};
</script>

<style scoped>
</style>